<template>
  <div>
    <navigation-sub
      :list="[
        {
          title: $t('commerce.baeminstore.name')
        },
        {
          title: $t('commerce.bMart.name')
        },
        {
          title: $t('commerce.gifts.name')
        }
      ]"
    />

    <section class="service-title-wrap">
      <h4 class="service-title">{{ $t('menuService.commerce') }}</h4>
    </section>

    <section class="service-list">
      <!-- 장보기/쇼핑 -->
      <article :id="hashTitle($t('commerce.baeminstore.name'))" class="article-anchor">
        <div class="service-box" :data-id="$t('commerce.baeminstore.name')">
          <div class="service-box-image">
            <p>
              <img src="~@/static/image/service/baeminstore.jpg" :alt="$t('commerce.baeminstore.name')">
            </p>
          </div>
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/new_logo_commerce.png" :alt="$t('commerce.baeminstore.name')">
            <html-view tag="p" :value="$t('commerce.baeminstore.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('commerce.baeminstore.content')" />
          </div>
        </div>
      </article>

      <!-- B마트 -->
      <article :id="hashTitle($t('commerce.bMart.name'))" class="article-anchor">
        <div class="service-box" :data-id="$t('commerce.bMart.name')">
          <div class="service-box-image">
            <p>
              <img src="~@/static/image/service/bmart.jpg" :alt="$t('commerce.bMart.name')">
            </p>
          </div>
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/new_logo_bmart.png" :alt="$t('commerce.bMart.name')">
            <html-view tag="p" :value="$t('commerce.bMart.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('commerce.bMart.content')" />
          </div>
        </div>
      </article>

      <!-- 선물하기 -->
      <article :id="hashTitle($t('commerce.gifts.name'))" class="article-anchor">
        <div class="service-box" :data-id="$t('commerce.gifts.name')">
          <div class="service-box-image">
            <p>
              <img src="~@/static/image/service/gift.jpg" :alt="$t('commerce.gifts.name')">
            </p>
          </div>
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/new_logo_gift.png" :alt="$t('commerce.gifts.name')">
            <html-view tag="p" :value="$t('commerce.gifts.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('commerce.gifts.content')" />
            <!--            <div class="btn-wrap">-->
            <!--              <a-->
            <!--                href="https://gift-pc.baemin.com/"-->
            <!--                class="btn-link"-->
            <!--                target="_blank"-->
            <!--                @click="setGtag({-->
            <!--                  name: '서비스_페이지 링크',-->
            <!--                  category: '커머스',-->
            <!--                  label: '서비스링크_선물하기',-->
            <!--                  page: '서비스'})"-->
            <!--              >{{ $t('commerce.gifts.site') }}<icon-blank /></a>-->
            <!--            </div>-->
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import gtag from '@/mixins/gtag'
import { hashTitle } from '@/util'

export default {
  components: {
    navigationSub: () => import('@/components/base/NavigationSub'),
    iconBlank: () => import('@/static/svg/blank.svg'),
  },
  mixins: [gtag],
  methods: { hashTitle },
}
</script>
